export default {"src":"/_next/static/media/breathalyser.mono.09e858ef.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};